module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jerome Veith\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Jerome Veith teaches at Seattle University. He is translator of The Heidegger Reader (IUP, 2009) and Günter Figal's Aesthetics as Phenomenology (IUP, 2014).")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/EgtHZb/tc-custom/9780253016041.jpg?1716662496460",
      "alt": "This image is the cover for the book Gadamer and the Transmission of History, Studies in Continental Thought"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Gadamer and the Transmission of History, Studies in Continental Thought\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Observing that humans often deal with the past in problematic ways, Jerome Veith looks to philosopher Hans-Georg Gadamer and his hermeneutics to clarify these conceptions of history and to present ways to come to terms with them. Veith fully engages Truth and Method as well as Gadamer's entire work and relationships with other German philosophers, especially Kant, Hegel, and Heidegger in this endeavor. Veith considers questions about language, ethics, cosmopolitanism, patriotism, self-identity, and the status of the humanities in the academy in this very readable application of Gadamer's philosophical practice.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0